import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RotateCounterclockwise"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 21V12C1.50083 11.1719 2.17192 10.5008 3 10.5H12C12.8281 10.5008 13.4992 11.1719 13.5 12V21C13.4992 21.8281 12.8281 22.4992 12 22.5H3C2.17192 22.4992 1.50083 21.8281 1.5 21ZM2.99999 12L2.99924 21H12V12H2.99999ZM12.75 1.5L13.8075 2.5575L11.8725 4.5H15.75C18.6481 4.50331 20.9967 6.85188 21 9.75V13.5H19.5V9.75C19.4975 7.67996 17.82 6.00248 15.75 6H11.8725L13.8075 7.9425L12.75 9L9 5.25L12.75 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RotateCounterclockwise.vue"]]);
